import React from 'react';

import { MainBox } from './IngredientDetails.style';
import type { IngredientsInfoContent } from '../Ingredients';

type IngredientDetailsProps = {
  activeIngredient: IngredientsInfoContent;
};

export const IngredientDetails = ({
  activeIngredient,
}: IngredientDetailsProps) => (
  <MainBox id={activeIngredient.title}>
    <p>
      <strong>{activeIngredient.title}</strong>
    </p>
    <p>{activeIngredient.detailsText}</p>
  </MainBox>
);
